import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

/**
 * Reuses the Patient List route when navigating to details/edit and back,
 * so the list state (page, filters, scroll, selection) is preserved.
 */
export class PatientListReuseStrategy implements RouteReuseStrategy {
  private storedRoute: DetachedRouteHandle | null = null;

  private isPatientListRoute(route: ActivatedRouteSnapshot): boolean {
    const path = route.routeConfig?.path ?? '';
    if (path !== '' && path !== 'patient-list') return false;
    let parent = route.parent;
    while (parent) {
      if (parent.routeConfig?.path === 'patient') return true;
      parent = parent.parent;
    }
    return false;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return this.isPatientListRoute(route);
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    if (handle) {
      this.storedRoute = handle;
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return this.isPatientListRoute(route) && this.storedRoute != null;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    if (this.isPatientListRoute(route)) {
      const handle = this.storedRoute;
      this.storedRoute = null;
      return handle;
    }
    return null;
  }
}
